import React, { lazy,Suspense, useEffect, useState } from "react";
import {isMobile, isTablet} from 'react-device-detect';
import { SplashScreen } from '../../utils/loadingComponents/SplashScreen';
import { LoadProjectSkeleton } from '../../utils/loadingComponents/LoadSkeleton';

import { useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { setIsMobile, setProjectUser } from "../../redux/actions";
import store from "../../redux/store";
import ApplicationService from "../../services/ApplicationService";
import FeedbackDialog from "../Feedback/FeedbackDialog";
import { getAppInsights } from "../../services/TelemetryService";
import { useDispatch } from "react-redux";

const UnAuthorizedComponent = lazy(() => import('./UnAuthorized/UnAuthorizedComponent'));
const SnapshotImageComponent = lazy(() => import('./SnapshotImage/SnapshotImageComponent'));
const ConstructionPortal = lazy(() => import('./Portal/ConstructionPortal'));
const ProjectComponent = lazy(() => import('./Home/ProjectComponent'));
const WidgetForExternalUser = lazy(() => import('./Widget/WidgetForExternalUser'));

const HomeComponent = lazy(() => import('./Viewer/HomeComponent'));


const ProjectComponentPage = () => (
  <Suspense fallback={<SplashScreen/>}>
    <ProjectComponent />
  </Suspense>
);
const HomeComponentPage = () => {
  const theme = useTheme();
  const isExternalUser : boolean = globalThis.location.pathname.split('/')[2] === 'widget';
  const lessThanXSmall = useMediaQuery(theme.breakpoints.down("xs"));
  const isMobileDevice = useMediaQuery(theme.breakpoints.down('md'));
  const [isUserActive, setIsUserActive] = useState<boolean>(true);
  const [showFeedback, setShowFeedback] = useState<boolean>(false);
  const [isLocalUser, setIsLocalUser] = useState<boolean>(false);
  const appInsights = getAppInsights();
  const dispatch = useDispatch();

  useEffect(() => {
    const mobile = isMobile || isTablet || isMobileDevice;

    if (mobile) {
      window.scrollTo(0, 1);
    }

    dispatch(setIsMobile(mobile));
  }, [dispatch, isMobileDevice]);

  useEffect(() => {
    ApplicationService.getUser().then((user) => {
      setIsUserActive(user.status);
      dispatch(setProjectUser(user));
      const isLocal = (user?.username || '').toLowerCase() === 'localhost';
      setIsLocalUser(isLocal);
      // Show feedback only for non-local user and non-widget viewer context
      if (!isExternalUser && !isLocal) {
        ApplicationService.getAskForFeedback()
          .then((flag) => {
            if (flag) setShowFeedback(true);
          })
          .catch(() => {
            // silently ignore askForFeedback errors
          });
      }
    });
  }, []);
 
  if(!isUserActive) {return <UnAuthorizedComponentPage />}

  return (
    <Suspense fallback={<LoadProjectSkeleton/>}>
      <HomeComponent lessThanXSmall={lessThanXSmall} isExternalUser = {isExternalUser} />
      <FeedbackDialog
        open={showFeedback && !isExternalUser && !isLocalUser}
        onClose={() => setShowFeedback(false)}
        onSubmit={(rating, comment, dontAskAgain) => {
          try {
            appInsights?.trackEvent({ name: 'UserFeedback' }, { rating: String(rating), comment: comment ?? '', dontAskAgain: dontAskAgain || false });
            ApplicationService.submitFeedback(rating, comment, dontAskAgain || false).catch(() => {});
          } catch {}
        }}
      />
    </Suspense>
  );
}
const ConstructionPortalPage = () => (
  <Suspense fallback={<></>}>
    <ConstructionPortal/>
  </Suspense>
);
const ProjectComponentPageForExternalUser = () => {
  const AppConfig = store.getState().config;
  const isExternalUser : boolean = globalThis.location.pathname.split('/')[2] === 'widget';
  const isEsv2User : boolean = globalThis.location.href.includes(AppConfig.isEasyStructure);
  const theme = useTheme();
  const lessThanXSmall = useMediaQuery(theme.breakpoints.down("xs"));

  if(isExternalUser && !isEsv2User){
    return (
      <Suspense fallback={<></>}>
        <WidgetForExternalUser  lessThanXSmall={lessThanXSmall} isExternalUser={isExternalUser} />
      </Suspense>
    );
  }else{
    return (<UnAuthorizedComponentPage />)
  }
}
const UnAuthorizedComponentPage = () => (
  <Suspense fallback={<></>}>
    <UnAuthorizedComponent/>
  </Suspense>
);

const SnapshotImageComponentPage = () => (
  <Suspense fallback={<></>}>
    <SnapshotImageComponent/>
  </Suspense>
);

export {
  ProjectComponentPage,
  HomeComponentPage,
  ConstructionPortalPage,
  UnAuthorizedComponentPage,
  SnapshotImageComponentPage,
  ProjectComponentPageForExternalUser
};
